const isMetricReportConfig = (
  config: ReportGenerator.Config | undefined,
): config is ReportGenerator.MetricReportConfig => {
  if (!config) {
    return false;
  }
  return config.generatorType === 'metricReport';
};

export default isMetricReportConfig;
